/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Client } from './';
import {
    ClientFromJSON,
    ClientFromJSONTyped,
    ClientToJSON,
} from './';
import type { ContractType } from './';
import {
    ContractTypeFromJSON,
    ContractTypeFromJSONTyped,
    ContractTypeToJSON,
} from './';
import type { Freelancer } from './';
import {
    FreelancerFromJSON,
    FreelancerFromJSONTyped,
    FreelancerToJSON,
} from './';
import type { ProjectContractResource } from './';
import {
    ProjectContractResourceFromJSON,
    ProjectContractResourceFromJSONTyped,
    ProjectContractResourceToJSON,
} from './';
import type { TimeAndMaterialsProjectContractDetailsResource } from './';
import {
    TimeAndMaterialsProjectContractDetailsResourceFromJSON,
    TimeAndMaterialsProjectContractDetailsResourceFromJSONTyped,
    TimeAndMaterialsProjectContractDetailsResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface TimeAndMaterialsProjectContractResource
 */
export interface TimeAndMaterialsProjectContractResource extends ProjectContractResource {
    /**
     * 
     * @type {TimeAndMaterialsProjectContractDetailsResource}
     * @memberof TimeAndMaterialsProjectContractResource
     */
    details: TimeAndMaterialsProjectContractDetailsResource;
}

/**
 * Check if a given object implements the TimeAndMaterialsProjectContractResource interface.
 */
export function instanceOfTimeAndMaterialsProjectContractResource(value: object): value is TimeAndMaterialsProjectContractResource {
    if (!('details' in value) || value['details'] === undefined) return false;
    return true;
}

export function TimeAndMaterialsProjectContractResourceFromJSON(json: any): TimeAndMaterialsProjectContractResource {
    return TimeAndMaterialsProjectContractResourceFromJSONTyped(json, false);
}

export function TimeAndMaterialsProjectContractResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimeAndMaterialsProjectContractResource {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ProjectContractResourceFromJSONTyped(json, ignoreDiscriminator),
        'details': TimeAndMaterialsProjectContractDetailsResourceFromJSON(json['details']),
    };
}

export function TimeAndMaterialsProjectContractResourceToJSON(value?: TimeAndMaterialsProjectContractResource | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ProjectContractResourceToJSON(value, true),
        'details': TimeAndMaterialsProjectContractDetailsResourceToJSON(value['details']),
    };
}

